var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _c("div", { staticClass: "col-5" }, [
        _c("h5", [_vm._v(_vm._s(_vm.pageTitle))]),
      ]),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("キャンセルする")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.register.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.hospitalCode,
                        expression: "hospital.hospitalCode",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "32",
                      autocomplete: "off",
                      placeholder: [[_vm.tenantCode]],
                      required: "",
                    },
                    domProps: { value: _vm.hospital.hospitalCode },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.hospital,
                          "hospitalCode",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(1),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.hospitalName,
                        expression: "hospital.hospitalName",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "120",
                      autocomplete: "off",
                      placeholder: [[_vm.tenantName]],
                      required: "",
                    },
                    domProps: { value: _vm.hospital.hospitalName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.hospital,
                          "hospitalName",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(2),
                _c("div", { staticClass: "col-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.firstTimeOut,
                        expression: "hospital.firstTimeOut",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "number",
                      min: "1",
                      max: "8760",
                      autocomplete: "off",
                      required: "",
                    },
                    domProps: { value: _vm.hospital.firstTimeOut },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.hospital,
                          "firstTimeOut",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._m(3),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(4),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isAvailableImage,
                        expression: "hospital.isAvailableImage",
                      },
                    ],
                    attrs: {
                      name: "isAvailableImage",
                      id: "imageOn",
                      type: "radio",
                      value: "true",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(_vm.hospital.isAvailableImage, "true"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.hospital,
                          "isAvailableImage",
                          "true"
                        )
                      },
                    },
                  }),
                  _c(
                    "label",
                    { staticClass: "radio-label", attrs: { for: "imageOn" } },
                    [_vm._v("利用する")]
                  ),
                ]),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isAvailableImage,
                        expression: "hospital.isAvailableImage",
                      },
                    ],
                    attrs: {
                      name: "isAvailableImage",
                      id: "imageOff",
                      type: "radio",
                      value: "false",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(_vm.hospital.isAvailableImage, "false"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.hospital,
                          "isAvailableImage",
                          "false"
                        )
                      },
                    },
                  }),
                  _c(
                    "label",
                    { staticClass: "radio-label", attrs: { for: "imageOff" } },
                    [_vm._v("利用しない")]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(5),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isHierarchyGroupEnabled,
                        expression: "hospital.isHierarchyGroupEnabled",
                      },
                    ],
                    attrs: {
                      name: "isHierarchyGroupEnabled",
                      id: "hierarchyOn",
                      type: "radio",
                      value: "true",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(
                        _vm.hospital.isHierarchyGroupEnabled,
                        "true"
                      ),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.hospital,
                          "isHierarchyGroupEnabled",
                          "true"
                        )
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "radio-label",
                      attrs: { for: "hierarchyOn" },
                    },
                    [_vm._v("利用する")]
                  ),
                ]),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isHierarchyGroupEnabled,
                        expression: "hospital.isHierarchyGroupEnabled",
                      },
                    ],
                    attrs: {
                      name: "isHierarchyGroupEnabled",
                      id: "hierarchyOff",
                      type: "radio",
                      value: "false",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(
                        _vm.hospital.isHierarchyGroupEnabled,
                        "false"
                      ),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.hospital,
                          "isHierarchyGroupEnabled",
                          "false"
                        )
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "radio-label",
                      attrs: { for: "hierarchyOff" },
                    },
                    [_vm._v("利用しない")]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(6),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isUseConference,
                        expression: "hospital.isUseConference",
                      },
                    ],
                    attrs: {
                      name: "isUseConference",
                      id: "conferenceOn",
                      type: "radio",
                      value: "true",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(_vm.hospital.isUseConference, "true"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.hospital, "isUseConference", "true")
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "radio-label",
                      attrs: { for: "conferenceOn" },
                    },
                    [_vm._v("利用する")]
                  ),
                ]),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isUseConference,
                        expression: "hospital.isUseConference",
                      },
                    ],
                    attrs: {
                      name: "isUseConference",
                      id: "conferenceOff",
                      type: "radio",
                      value: "false",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(_vm.hospital.isUseConference, "false"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.hospital,
                          "isUseConference",
                          "false"
                        )
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "radio-label",
                      attrs: { for: "conferenceOff" },
                    },
                    [_vm._v("利用しない")]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(7),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isThreadFunctionEnabled,
                        expression: "hospital.isThreadFunctionEnabled",
                      },
                    ],
                    attrs: {
                      name: "isThreadFunctionEnabled",
                      id: "threadOn",
                      type: "radio",
                      value: "true",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(
                        _vm.hospital.isThreadFunctionEnabled,
                        "true"
                      ),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.hospital,
                          "isThreadFunctionEnabled",
                          "true"
                        )
                      },
                    },
                  }),
                  _c(
                    "label",
                    { staticClass: "radio-label", attrs: { for: "threadOn" } },
                    [_vm._v("利用する")]
                  ),
                ]),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isThreadFunctionEnabled,
                        expression: "hospital.isThreadFunctionEnabled",
                      },
                    ],
                    attrs: {
                      name: "isThreadFunctionEnabled",
                      id: "threadOff",
                      type: "radio",
                      value: "false",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(
                        _vm.hospital.isThreadFunctionEnabled,
                        "false"
                      ),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.hospital,
                          "isThreadFunctionEnabled",
                          "false"
                        )
                      },
                    },
                  }),
                  _c(
                    "label",
                    { staticClass: "radio-label", attrs: { for: "threadOff" } },
                    [_vm._v("利用しない")]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(8),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isEditableTeam,
                        expression: "hospital.isEditableTeam",
                      },
                    ],
                    attrs: {
                      name: "isEditableTeam",
                      id: "teamOn",
                      type: "radio",
                      value: "true",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(_vm.hospital.isEditableTeam, "true"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.hospital, "isEditableTeam", "true")
                      },
                    },
                  }),
                  _c(
                    "label",
                    { staticClass: "radio-label", attrs: { for: "teamOn" } },
                    [_vm._v("許可する")]
                  ),
                ]),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isEditableTeam,
                        expression: "hospital.isEditableTeam",
                      },
                    ],
                    attrs: {
                      name: "isEditableTeam",
                      id: "teamOff",
                      type: "radio",
                      value: "false",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(_vm.hospital.isEditableTeam, "false"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.hospital, "isEditableTeam", "false")
                      },
                    },
                  }),
                  _c(
                    "label",
                    { staticClass: "radio-label", attrs: { for: "teamOff" } },
                    [_vm._v("許可しない")]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(9),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.useFederation,
                        expression: "hospital.useFederation",
                      },
                    ],
                    attrs: {
                      name: "useFederation",
                      id: "federationOn",
                      type: "radio",
                      value: "true",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(_vm.hospital.useFederation, "true"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.hospital, "useFederation", "true")
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "radio-label",
                      attrs: { for: "federationOn" },
                    },
                    [_vm._v("許可する")]
                  ),
                ]),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.useFederation,
                        expression: "hospital.useFederation",
                      },
                    ],
                    attrs: {
                      name: "useFederation",
                      id: "federationOff",
                      type: "radio",
                      value: "false",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(_vm.hospital.useFederation, "false"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.hospital, "useFederation", "false")
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "radio-label",
                      attrs: { for: "federationOff" },
                    },
                    [_vm._v("許可しない")]
                  ),
                ]),
              ]),
            ]),
            this.hospital.useFederation == "true"
              ? _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(10),
                    _c("div", { staticClass: "col-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.hospital.idProvider,
                            expression: "hospital.idProvider",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          maxlength: "40",
                          autocomplete: "off",
                          placeholder: "IDプロバイダー名",
                          required:
                            this.hospital.useFederation == "true"
                              ? true
                              : false,
                        },
                        domProps: { value: _vm.hospital.idProvider },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.hospital,
                              "idProvider",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(11),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isDoubleLoginDisabled,
                        expression: "hospital.isDoubleLoginDisabled",
                      },
                    ],
                    attrs: {
                      name: "isDoubleLoginDisabled",
                      id: "doubleLoginOn",
                      type: "radio",
                      value: "true",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(
                        _vm.hospital.isDoubleLoginDisabled,
                        "true"
                      ),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.hospital,
                          "isDoubleLoginDisabled",
                          "true"
                        )
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "radio-label",
                      attrs: { for: "doubleLoginOn" },
                    },
                    [_vm._v("制限する")]
                  ),
                ]),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hospital.isDoubleLoginDisabled,
                        expression: "hospital.isDoubleLoginDisabled",
                      },
                    ],
                    attrs: {
                      name: "isDoubleLoginDisabled",
                      id: "doubleLoginOff",
                      type: "radio",
                      value: "false",
                      required: "",
                    },
                    domProps: {
                      checked: _vm._q(
                        _vm.hospital.isDoubleLoginDisabled,
                        "false"
                      ),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.hospital,
                          "isDoubleLoginDisabled",
                          "false"
                        )
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "radio-label",
                      attrs: { for: "doubleLoginOff" },
                    },
                    [_vm._v("制限しない")]
                  ),
                ]),
              ]),
            ]),
            _vm.isSuper
              ? _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(12),
                    _c("div", { staticClass: "col-4" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.hospital.enableStandardPhone,
                            expression: "hospital.enableStandardPhone",
                          },
                        ],
                        attrs: {
                          name: "enableStandardPhone",
                          id: "enableStandardPhone",
                          type: "radio",
                          value: "true",
                          required: "",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.hospital.enableStandardPhone,
                            "true"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.hospital,
                              "enableStandardPhone",
                              "true"
                            )
                          },
                        },
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "radio-label",
                          attrs: { for: "enableStandardPhone" },
                        },
                        [_vm._v("利用する")]
                      ),
                    ]),
                    _c("div", { staticClass: "col-4" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.hospital.enableStandardPhone,
                            expression: "hospital.enableStandardPhone",
                          },
                        ],
                        attrs: {
                          name: "enableStandardPhone",
                          id: "disableStandardPhone",
                          type: "radio",
                          value: "false",
                          required: "",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.hospital.enableStandardPhone,
                            "false"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.hospital,
                              "enableStandardPhone",
                              "false"
                            )
                          },
                        },
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "radio-label",
                          attrs: { for: "disableStandardPhone" },
                        },
                        [_vm._v("利用しない")]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "btn btn-info btn btn-block",
                attrs: { id: "register_button", type: "submit" },
              },
              [_vm._v("登録する")]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [_c("label", [_vm._v("ID")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [_c("label", [_vm._v("名称")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("有効期限")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-7" }, [
      _c("label", { staticStyle: { "margin-top": "0.5rem" } }, [
        _vm._v("時間"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("チャットの画像送信")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("階層グループ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("ビデオ通話カンファレンス")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("スレッド機能")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("アプリからのチーム追加・編集")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("Microsoftアカウントでログイン")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("IDプロバイダー名")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("同一ユーザーでの複数端末からの重複ログイン")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("label", [_vm._v("外線・内線連動")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }